"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LauncherScreen = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importStar(require("react"));
const react_native_1 = require("react-native");
const AppGrid_1 = require("../AppGrid");
const BlueBaseImageBackground = core_1.getComponent('BlueBaseImageBackground');
const EmptyState = core_1.getComponent('LauncherEmptyState', 'EmptyState');
const defaultStyles = (theme) => ({
    root: {
        flex: 1,
        paddingHorizontal: theme.spacing.unit * 2,
    },
});
const LauncherScreen = (props) => {
    const styles = core_1.useStyles('LauncherScreen', props, defaultStyles);
    const BB = core_1.useBlueBase();
    const [plugins, setPlugins] = react_1.useState([]);
    react_1.useEffect(() => {
        async function loadPlugins() {
            const enabledPlugins = await BB.Plugins.getAllEnabled();
            const plugins = enabledPlugins.filter(p => !!p.indexRoute);
            setPlugins(plugins);
        }
        loadPlugins();
    }, []);
    if (!plugins || plugins.length === 0) {
        return (react_1.default.createElement(components_1.View, { testID: "view", style: styles.root },
            react_1.default.createElement(EmptyState, null)));
    }
    return (react_1.default.createElement(BlueBaseImageBackground, { style: { flex: 1 }, resizeMode: "contain", source: "launcher" },
        react_1.default.createElement(react_native_1.ScrollView, { style: styles.root },
            react_1.default.createElement(AppGrid_1.AppGrid, { plugins: plugins }))));
};
exports.LauncherScreen = LauncherScreen;
exports.LauncherScreen.displayName = 'LauncherScreen';
